import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import DeviceService from "./apiServices/DeviceService";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        appTitle : "NotifyHook",
        status: '',
        token: localStorage.getItem('token') || '',
        device : JSON.parse(localStorage.getItem('device')) || ''
    },
    mutations: {
        auth_request(state){
            state.status = 'loading'
        },
        auth_success(state, payload){
            state.status = 'success'
            state.token = payload.token
            state.device = payload.device
        },
        auth_error(state){
            state.status = 'error'
        },
        logout(state){
            state.status = ''
            state.token = ''
            state.device = ''
        },
    },
    actions: {
        register({commit}, device){
            return new Promise((resolve, reject) => {
                commit('auth_request')
                DeviceService.register(device)
                    .then(response => {
                        const token = response.data.authCode;
                        const device = response.data;
                        localStorage.setItem('token', token);
                        localStorage.setItem('device', JSON.stringify(device))
                        axios.defaults.headers.common['Authorization'] = token;
                        commit('auth_success', {
                            token: token,
                            device: device
                        });
                        resolve(response);
                    })
                    .catch(error => {
                        commit('auth_error', error)
                        localStorage.removeItem('token')
                        localStorage.removeItem('device')
                        reject(error)
                    })
            })
        },
        logout({commit}){
            return new Promise((resolve) => {
                commit('logout')
                localStorage.removeItem('token')
                localStorage.removeItem('device')
                delete axios.defaults.headers.common['Authorization']
                resolve()
            })
        }
    },
    getters: {
        isLogin: state => {
            return state.token !== "";
        },
        getDevice: state => {
            return state.device
        }
    }
})
